export default __webpack_public_path__ + "static/realWorldImg1-1e0d6dd8ff58f5aaf957c78dcbf51371.webp";